export default "__VITE_ASSET__62198705__"